import HomeHeader from "containers/Home/HomeHeader/HomeHeader";
import React, { useState, useEffect } from "react";
import UserDetailsHeader from "./UserDetailsHeader/UserDetailsHeader";
import "../UserDetails/UserDetails.css";
import InputBar from "components/InputBar/InputBar";
import SelectInput from "components/SelectInput/SelectInput";
import greenTick from "../../assets/icons/accept-icon.svg";
import Button from "components/Button/Button";
import {
  getUserHashToken,
  getUserPhone,
  getVendingMachineUuid,
} from "utils/commonMethods";
import { API_KEYS } from "constants/apiEndpoints";
import { APP_ROUTES } from "constants/routes";
import { connect } from "react-redux";

function UserDetails(props) {
  const componentTexts = window.appTexts.components.user_details_form;
  const initialState = {};
  const [state, setState] = useState(initialState);
  const [data, setData] = useState(props.location.state.data);

  const onChangeHandler = (name, value) => {
    setState({ ...state, [name]: value });
  };

  const submitHandler = () => {
    props.history.push(APP_ROUTES.HOME_PAGE.url);
  };

  const userRequestBody = {
    ...state,
    phone_no: getUserPhone(),
    hash: getUserHashToken(),
    uuid: getVendingMachineUuid(),
  };
  return (
    <>
      <div className="flex-container">
        <p style={{ textAlign: "center" }}>
          Experience{" "}
          <em style={{ fontSize: "1.5rem" }}>
            <b>Free Samples</b>
          </em>{" "}
          <br />
          from exciting brands!
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "50vw",
          }}
        >
          <img
            src={props.clDetails.verification_screen_images}
            style={{
              width: "100%",
              // height: "200px",
            }}
          />
        </div>
      </div>
      <section
        style={{ padding: "0 1rem", fontWeight: "900" }}
        className="custom-class"
      >
        <div style={{}}>
          <p>{componentTexts.details_requirement}</p>
        </div>
      </section>

      <section className="flex-container" style={{ paddingTop: "0px" }}>
        {data?.map((ele) => (
          <div className="input-area">
            {ele.key === "gender" ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ margin: "0 0 0.5rem 0.2rem" }}>
                  {ele.key[0].toUpperCase() + ele.key.substring(1)}
                </div>
                <SelectInput
                  className="gender"
                  name={ele.key}
                  type="select"
                  customClassName="input-bar"
                  value={state[ele.key]}
                  options={[
                    {
                      name: "MALE",
                      value: "MALE",
                    },
                    {
                      name: "FEMALE",
                      value: "FEMALE",
                    },
                  ]}
                  onChange={onChangeHandler}
                  inputProps={{
                    placeholder: "Select Gender",
                  }}
                />
                {/* {data
                  ?.filter((ele) => ele.key === "age")
                  .map((ele1) => (
                    <InputBar
                      className="gender"
                      type={ele1.type === "integer" ? "number" : "text"}
                      name={ele1.key}
                      customClassName="input-bar"
                      value={state[ele1.key]}
                      onChange={onChangeHandler}
                      inputProps={{
                        placeholder:
                          ele1.key[0].toUpperCase() + ele1.key.substring(1),
                      }}
                    />
                  ))} */}
              </div>
            ) : (
              <div>
                <div style={{ margin: "0 0 0.5rem 0.2rem" }}>
                  {ele.key[0].toUpperCase() + ele.key.substring(1)}
                </div>
                <InputBar
                  type={ele.type === "integer" ? "number" : "text"}
                  name={ele.key}
                  customClassName="user-Info"
                  value={state[ele.key]}
                  onChange={onChangeHandler}
                  inputProps={{
                    placeholder: `Enter ${
                      ele.key[0].toUpperCase() + ele.key.substring(1)
                    }`,
                  }}
                />
              </div>
            )}
          </div>
        ))}{" "}
        <div style={{ display: "flex" }}>
          <img
            src={greenTick}
            alt="no image"
            style={{
              width: "16px",
              height: "25px",
              marginRight: "5px",
              marginTop: "16px",
            }}
          />
          <p
            style={{
              marginBottom: "30px",
              color: "grey",
              fontFamily: "Poppins ",
            }}
          >
            {" "}
            {/* Offers basis profile eligibility | 1 item only once per user. T&Cs
          apply. */}
            You hereby agree to the terms as mentioned on{" "}
            <span
              style={{
                fontWeight: "600",
                color: "black",
                fontFamily: "Poppins ",
              }}
            >
              www.samplrr.in
            </span>
          </p>
        </div>
        <div className="user-details-button" style={{ color: "#050A30" }}>
          <Button
            onClick={submitHandler}
            loaderApiKey={API_KEYS.CREATE_USER_DETAILS}
            apiRequestBody={userRequestBody}
          >
            Continue
          </Button>
        </div>
      </section>
    </>
  );
}
const mapStateToProps = (state) => ({
  clDetails: state.clDetailsReducer,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails);
